export default __webpack_public_path__ + "9585580230392fee3fdc7d8e632e404e.ttf";